import { render } from "./AdminAccommodationInquiries.vue?vue&type=template&id=14d49ea9&ts=true"
import script from "./AdminAccommodationInquiries.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationInquiries.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__